function CategorySVG({ style, ...props }) {
    return (
        <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={style}
            {...props}
        >
            <mask
                id="mask0_3107_2507"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="3"
                y="5"
                width="24"
                height="20"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.4375 7.5C3.4375 6.4625 4.275 5.625 5.3125 5.625C6.35 5.625 7.1875 6.4625 7.1875 7.5C7.1875 8.5375 6.35 9.375 5.3125 9.375C4.275 9.375 3.4375 8.5375 3.4375 7.5ZM3.4375 15C3.4375 13.9625 4.275 13.125 5.3125 13.125C6.35 13.125 7.1875 13.9625 7.1875 15C7.1875 16.0375 6.35 16.875 5.3125 16.875C4.275 16.875 3.4375 16.0375 3.4375 15ZM5.3125 20.625C4.275 20.625 3.4375 21.475 3.4375 22.5C3.4375 23.525 4.2875 24.375 5.3125 24.375C6.3375 24.375 7.1875 23.525 7.1875 22.5C7.1875 21.475 6.35 20.625 5.3125 20.625ZM25.3125 23.75H10.3125C9.625 23.75 9.0625 23.1875 9.0625 22.5C9.0625 21.8125 9.625 21.25 10.3125 21.25H25.3125C26 21.25 26.5625 21.8125 26.5625 22.5C26.5625 23.1875 26 23.75 25.3125 23.75ZM10.3125 16.25H25.3125C26 16.25 26.5625 15.6875 26.5625 15C26.5625 14.3125 26 13.75 25.3125 13.75H10.3125C9.625 13.75 9.0625 14.3125 9.0625 15C9.0625 15.6875 9.625 16.25 10.3125 16.25ZM10.3125 8.75C9.625 8.75 9.0625 8.1875 9.0625 7.5C9.0625 6.8125 9.625 6.25 10.3125 6.25H25.3125C26 6.25 26.5625 6.8125 26.5625 7.5C26.5625 8.1875 26 8.75 25.3125 8.75H10.3125Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0_3107_2507)">
                <rect
                    width="30"
                    height="30"
                    fill="var(--foreground)"
                    style={style}
                />
            </g>
        </svg>
    );
}

export default CategorySVG;
